module.exports = __webpack_public_path__ + "static/media/bussiness1.4d69f4f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_websitesec/bussiness1.png
// module id = 794
// module chunks = 0